module.exports = __webpack_public_path__ + "static/our-technology__hero.a9937614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/our-technology__hero.jpg
// module id = 529
// module chunks = 46232061722965